var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterlogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 93.49 86.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -747.79,
    y1: -1838.11,
    x2: -746.79,
    y2: -1838.11,
    gradientTransform: "translate(14198.24 -89643.89) scale(18.99 -48.79)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe89b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fee091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fdcd76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#fbaf4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb9e34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: -1838.11,
    y2: -1838.11,
    gradientTransform: "translate(14271.54 -89643.89) scale(18.99 -48.79)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -753.14,
    y1: -1835.33,
    x2: -752.14,
    y2: -1835.33,
    gradientTransform: "translate(20084.42 -100016.88) scale(26.62 -54.51)",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg2575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "footer_logo",
    "data-name": "footer logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28648",
    "data-name": "Group 28648"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28646",
    "data-name": "Group 28646"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29860",
    "data-name": "Path 29860",
    className: "cls-2",
    d: "M14.73,86.05l-6.47-8.89-2.42,2.51v6.38H1.25v-20.88H5.84v9.13l8.47-9.13h5.55l-8.5,8.86,8.89,12.02h-5.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29861",
    "data-name": "Path 29861",
    className: "cls-2",
    d: "M29.2,86.05v-20.88h4.59v20.88h-4.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29862",
    "data-name": "Path 29862",
    className: "cls-2",
    d: "M59.63,86.05l-10.11-13.27v13.27h-4.54v-20.88h4.24l9.79,12.86v-12.86h4.53v20.88h-3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29863",
    "data-name": "Path 29863",
    className: "cls-2",
    d: "M84.56,86.42c-6.5,0-10.98-4.56-10.98-10.74v-.06c-.05-5.92,4.71-10.76,10.63-10.8,.11,0,.21,0,.32,0,3-.16,5.95,.87,8.2,2.86l-2.89,3.49c-1.47-1.4-3.43-2.16-5.46-2.12-3.45,.15-6.13,3.05-6,6.5v.06c0,3.82,2.62,6.62,6.32,6.62,1.54,.05,3.05-.39,4.33-1.25v-2.98h-4.62v-3.97h9.07v9.07c-2.48,2.15-5.64,3.32-8.92,3.31h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28647",
    "data-name": "Group 28647"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29864",
    "data-name": "Path 29864",
    className: "cls-1",
    d: "M18.99,54.51L3.42,6.85c-.12-.6-.61-1.05-1.22-1.12h-.85c-.75,0-1.35,.88-1.35,1.97V54.51H18.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29865",
    "data-name": "Path 29865",
    className: "cls-4",
    d: "M92.28,54.51V7.69c0-1.09-.61-1.97-1.35-1.97h-.85c-.61,.07-1.1,.52-1.22,1.12l-15.57,47.66h18.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29866",
    "data-name": "Path 29866",
    className: "cls-3",
    d: "M59.46,54.51L48.08,1.56c-.23-1.06-1.27-1.74-2.33-1.51-.76,.16-1.35,.75-1.51,1.51l-11.39,52.95h26.62Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterlogo);
export default __webpack_public_path__ + "static/media/footerlogo.dd83834e57796b2f279d517e86dedbf7.svg";
export { ForwardRef as ReactComponent };